import { render, staticRenderFns } from "./pcbfile.vue?vue&type=template&id=b75054f4&scoped=true"
import script from "./pcbfile.vue?vue&type=script&lang=js"
export * from "./pcbfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75054f4",
  null
  
)

export default component.exports